export default __webpack_public_path__ + "static/media/litho-landing-page-icon-05.03fc76b7.jpg";